import _ from 'lodash'

const ID_PATHS = [
  'user_id',
  'userId',
  'user.id',
  'user.data.id',
  'usuario_id',
  'usuarioId',
  'usuario.id',
  'usuario.data.id',
  'responsavel_id',
  'responsavelId',
  'responsavel.id',
  'responsavel.data.id',
  'assigned_user_id',
  'assignedUserId',
  'assigned_user.id',
  'assigned_user.data.id',
  'assignedUser.id',
  'assignedUser.data.id'
]

const NAME_PATHS = [
  'user_name',
  'userName',
  'user.name',
  'user.data.name',
  'usuario_name',
  'usuarioName',
  'usuario.nome',
  'usuario.name',
  'usuario.data.nome',
  'usuario.data.name',
  'responsavel_name',
  'responsavelName',
  'responsavel.nome',
  'responsavel.name',
  'responsavel.data.nome',
  'responsavel.data.name',
  'assigned_user_name',
  'assignedUserName',
  'assigned_user.name',
  'assigned_user.data.name',
  'assignedUser.name',
  'assignedUser.data.name'
]

const RELATION_KEYS = ['user', 'usuario', 'responsavel', 'assigned_user', 'assignedUser']

const isDefinedValue = (value) => value !== null && typeof value !== 'undefined' && value !== ''

const resolveRelationValue = (item, relationKey, field) => {
  const relation = _.get(item, relationKey)
  if (!isDefinedValue(relation)) {
    return null
  }

  if ((field === 'id' && typeof relation === 'number') || (field === 'id' && typeof relation === 'string')) {
    return relation
  }

  if (typeof relation !== 'object') {
    return null
  }

  return _.find([
    _.get(relation, field),
    _.get(relation, `data.${field}`)
  ], isDefinedValue) || null
}

export const getAssignedUserId = (item) => {
  if (!item || typeof item !== 'object') return null

  return _.find([
    ...ID_PATHS.map(path => _.get(item, path)),
    ...RELATION_KEYS.map(key => resolveRelationValue(item, key, 'id'))
  ], isDefinedValue) || null
}

export const getAssignedUserName = (item) => {
  if (!item || typeof item !== 'object') return ''

  return _.find([
    ...NAME_PATHS.map(path => _.get(item, path)),
    ...RELATION_KEYS.map(key => resolveRelationValue(item, key, 'name')),
    ...RELATION_KEYS.map(key => resolveRelationValue(item, key, 'nome'))
  ], (value) => typeof value === 'string' && value.trim().length > 0) || ''
}



// WEBPACK FOOTER //
// ./src/utils/assignedUser.js